var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ShoppingManageService from "../../../../api/ShoppingManageService";
var ActivityPreview = (function (_super) {
    __extends(ActivityPreview, _super);
    function ActivityPreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goodsDetail = [];
        _this.ListData = [
            {
                goods: [{ goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '130' },
                    { goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '131' },
                    { goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '132' },
                    { goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '133' },
                    { goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '134' },
                    { goods_name: '菠萝', min_order_amount: '36', goods_unit_name: 'kg', goods_id: '135' }],
                goods_type_id: '100',
                goods_type_name: '水果蔬菜'
            }
        ];
        _this.tablist = [
            {
                goods_type_name: '水果蔬菜',
                goods_type_id: '100'
            },
            {
                goods_type_name: '海鲜水产',
                goods_type_id: '101'
            },
            {
                goods_type_name: '牛奶乳品',
                goods_type_id: '102'
            },
            {
                goods_type_name: '半成品',
                goods_type_id: '103'
            }
        ];
        return _this;
    }
    ActivityPreview.prototype.onListChanged = function (val, oldVal) {
        if (oldVal.length == 0) {
            this.previewBtn();
        }
    };
    ActivityPreview.prototype.previewBtn = function () {
        var _this = this;
        this.tablist = [];
        this.service = ShoppingManageService.getInstance();
        var goodIds = [];
        this.selectGoods.forEach(function (item) {
            goodIds.push(item.goods_id);
        });
        var params = {
            goods_ids: goodIds.length != 0 ? goodIds.join(',') : ''
        };
        this.service.activityPriview(params).then(function (res) {
            var handleData = [], listData = [];
            var DATA = Array.isArray(res.data.data) ? res.data.data : [];
            DATA.map(function (v, index) {
                v.children.forEach(function (v) {
                    listData.push(v);
                    handleData.push({ 'goods_type_name': v.goods_type_name, 'goods_type_id': v.goods_type_id });
                });
            });
            _this.ListData = listData;
            _this.tablist = handleData;
            _this.$forceUpdate();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], ActivityPreview.prototype, "selectGoods", void 0);
    __decorate([
        Prop({
            default: "",
            type: String
        })
    ], ActivityPreview.prototype, "typeName", void 0);
    __decorate([
        Watch('selectGoods')
    ], ActivityPreview.prototype, "onListChanged", null);
    ActivityPreview = __decorate([
        Component({
            components: {}
        })
    ], ActivityPreview);
    return ActivityPreview;
}(Vue));
export default ActivityPreview;
